import chunk from 'lodash/chunk';

import { Carousel } from '~src/components/Carousel';

import { HeatPumpCardNorlys } from '../../ProductCard/HeatPump';
import { useCarouselBreakPoints } from '../util';
import { getHeatPumpKey, getHeatPumpTag } from '../util/heatPump';
import { HeatPumpInformationProps } from './types';

export const HeatPumpInformationDesktopNorlys = ({
  heatPumpProducts,
  type = 'arrows',
  onClick,
  selectedOutdoorUnitID,
}: HeatPumpInformationProps) => {
  const amount = useCarouselBreakPoints();
  const { heatPumpIndoorUnit, heatPumpOutdoorUnit } = heatPumpProducts[0] ?? {};

  const items = chunk(heatPumpProducts, amount).map((heatPumps, outerIndex) => (
    <div
      key={`${heatPumpOutdoorUnit?.id}-${heatPumpIndoorUnit?.id}`}
      style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}
    >
      {heatPumps.map((innerProducts, innerIndex) => {
        const { heatPumpOutdoorUnit: outdoorUnit, heatPumpIndoorUnit: indoorUnit } = innerProducts;

        return (
          <HeatPumpCardNorlys
            key={getHeatPumpKey(outdoorUnit, indoorUnit)}
            heatPumpOffer={innerProducts}
            {...{
              selected: outdoorUnit?.id === selectedOutdoorUnitID,
              onClick: () => onClick(innerProducts),
              tag: getHeatPumpTag(outerIndex + innerIndex, outdoorUnit?.noiseLevel),
            }}
          />
        );
      })}
    </div>
  ));

  return <Carousel items={items} type={type} />;
};
